import { Box, Typography } from '@mui/material';

interface SidebarSectionLabelProps {
  label: string;
}

export default function SidebarSectionLabel({ label }: SidebarSectionLabelProps) {
  return (
    <Box
      sx={{
        px: 2.5
        // pt: 1,
        // pb: 0.5,
      }}
    >
      <Typography
        variant='caption'
        sx={{
          color: '#777777',
          fontWeight: 500,
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
          fontSize: '11px',
          lineHeight: 1.2
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
